module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card admin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._t("header", [_vm._v(_vm._s(_vm.$route.meta.label))])], 2), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_vm._t("footer")], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c16dce1e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-c16dce1e"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Admin/Components/AdminCard.vue
// module id = 1069
// module chunks = 1